/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */

import React, { useContext, useState, useEffect } from 'react';
import { Formik } from 'formik';

import { DialogComponent } from 'components/index';
import { ButtonContainer } from 'components/Button';
import { ResponsiveTable } from '@fitinsur/components';
import {
    LoaderContext
} from '@fitinsur/contexts';

import { Button } from './styles';

import {
    useGetEconomicGroupHeadStatement
} from '@fitinsur/services/EconomicGroupService';

export default function EconomicGroupStatement({ formik, visible, modalEconomicGroup, setModalEconomicGroup, economicGroup }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const [operationInstallments, setOperationInstallments] = useState([]);
    const [dialog, setDialog] = useState({
        visible: false,
        title: '',
        icon: 'times-circle',
        args: null,
        type: ''
    });
    const columnsInstallments = [        
        {
            title: "APÓLICE/ENDOSSO",
            key: "referenceNumber",
            value: "referenceNumber",
            sortKey: 'referenceNumber',
            minWidth: 5,
        },
        {
            title: "COTAÇÃO",
            key: "idOperationQuote",
            value: "idOperationQuote",
            sortKey: "idOperationQuote"
        },
        {
            title: "EXPOSIÇÃO VIGENTE",
            value: "consumedLimit",
            key: "consumedLimit",
            sortKey: 'consumedLimit'
        },
        {
            title: "MINUTADO (90 DIAS)",
            value: "draftedLimit",
            key: "draftedLimit",
            sortKey: 'draftedLimit',
        },
        {
            title: "TOMADOR",
            value: "borrower",
            key: "borrower",
            sortKey: 'borrower',
            notLastColumnAlign: true
        }
    ];

    const {
        data: useGetEconomicGroupHeadStatementData,
        loading: useGetEconomicGroupHeadStatementLoading,
        error: useGetEconomicGroupHeadStatementError,
        status: useGetEconomicGroupHeadStatementStatus,
        request: useGetEconomicGroupHeadStatementRequest
    } = useGetEconomicGroupHeadStatement(modalEconomicGroup);

    const modalOff = () => {
        setDialog(prev => ({ ...prev, visible: false }));
        setModalEconomicGroup(false);
    };

    const modalOn = async () => {
        const economicGroupHeadStatement = economicGroup.find(economicGroup => economicGroup.isHead === true)?.idOperation;

        if (visible) await useGetEconomicGroupHeadStatementRequest(economicGroupHeadStatement);
    };

    useEffect(() => {
        if (useGetEconomicGroupHeadStatementStatus === 200) {
            const { value } = useGetEconomicGroupHeadStatementData;
            setOperationInstallments(value);
            setDialog(prev => ({ ...prev, visible, title: 'Extrato Grupo Econômico' }));
        }
    }, [useGetEconomicGroupHeadStatementStatus]);

    useEffect(() => {
    document.addEventListener("mousedown", modalOff);
    return () => document.removeEventListener("mousedown", modalOff);
    });

    useEffect(() => {
        updateIsLoadingStatus(useGetEconomicGroupHeadStatementLoading);
    }, [useGetEconomicGroupHeadStatementLoading]);

    useEffect(() => {
        if (operationInstallments.length >= 1) {
            setDialog(prev => ({ ...prev, visible, title: 'Extrato Grupo Econômico' }));
        } else {
            modalOn();
        }
    }, [visible]);

    return (
        <DialogComponent
        icon={dialog.icon}
        title={dialog.title}
        size="90%"
        show={dialog.visible}
        setDialog={setDialog}
        customTitle
        >
            <Formik
                innerRef={formik}
            >   
                <ResponsiveTable columns={columnsInstallments} data={operationInstallments}/>
            </Formik>
           <ButtonContainer><Button onClick={() => modalOff()}>&lt; Voltar</Button></ButtonContainer>
        </DialogComponent>
    );
}